import Swiper from "swiper";
import { Pagination } from "swiper/modules";

(function () {
  const swiperSliders = document.querySelectorAll(".com-newsslider__slider");

  let newsSwiper = [];

  for (let i = 0; i < swiperSliders.length; i++) {
    newsSwiper[i] = new Swiper(swiperSliders[i], {
      modules: [Pagination],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 15,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        900: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
      },
    });
  }

  const loadMoreBtn = document.getElementById('load-more');
  if (!loadMoreBtn) return;

  loadMoreBtn.addEventListener('click', function() {
      let currentPage = parseInt(loadMoreBtn.dataset.page, 10);
      const maxPages = parseInt(loadMoreBtn.dataset.max, 10);
      const query = JSON.parse(loadMoreBtn.dataset.query);

      if (currentPage >= maxPages) return;

      loadMoreBtn.textContent = "Lädt ...";

      const formData = new FormData();
      formData.append('action', 'kb_load_more');
      formData.append('query', JSON.stringify(query));
      formData.append('page', currentPage);

      jQuery.ajax({
          url: globalvars.ajaxurl,
          type: 'POST',
          data: {
              action: 'kb_load_more',
              nonce: globalvars.ajax_nonce,
              query: JSON.stringify(query),
              page: currentPage
          },
          success: function(data) {
              document.getElementById('archives-wrapper').insertAdjacentHTML('beforeend', data);
              currentPage++;
              loadMoreBtn.dataset.page = currentPage;
              if (currentPage >= maxPages) {
                loadMoreBtn.style.display = 'none';
              } else {
                loadMoreBtn.textContent = "Weitere News";
              }
          },
          error: function() {
              loadMoreBtn.textContent = "Fehler!";
          }
      });
  });
})();
 